'use client';
import React from 'react';
import { useReferralTracker } from '@/hooks/useReferralTracking';
import CareersList from '@/components/Careers/CareersList';
interface CareerPageClientProps {
  type: string;
}

export const CareerPageClient: React.FC<CareerPageClientProps> = ({ type }) => {
  useReferralTracker();
  return (
    <div className="py-4 px-4 md:px-8 lg:px-20 bg-white">
      <CareersList type={type} prefix="careers" />
    </div>
  );
};
